export const AUTHENTICATION = "AUTHENTICATION";
export const API_SERVICE = "API_SERVICE";
export const POST_MESSAGE_SERVICE = "POST_MESSAGE_SERVICE";
export const NOTIFICATION_SERVICE = "NOTIFICATION_SERVICE";
export const ERROR_HANDLER = "ERROR_HANDLER";
